import { EXPERIAN_FORM } from '../constants';

export const getExperianDetails = (payload, routeProps, submitPrivacyRequestPayload) => ({
    type: EXPERIAN_FORM.GET_EXPERIAN_DETAILS,
    payload: {
        payload,
        routeProps,
        submitPrivacyRequestPayload
    }
})

export const verifyExperianDetails = (payload, routeProps, submitPrivacyRequestPayload) => ({
    type: EXPERIAN_FORM.VERIFY_EXPERIAN_DETAILS,
    payload: {
        payload,
        routeProps,
        submitPrivacyRequestPayload
    }
})